<template>
  <div v-if="showAll" class="page-container">
    <div id="app">
      <server-error-page v-if="serverError"></server-error-page>
      <router-view v-else />
    </div>
  </div>
</template>
<script>
import ServerErrorPage from '@/views/ServerErrorPage';
import { mapGetters } from 'vuex';
export default {
  components: { ServerErrorPage },
  data() {
    return {
      serverError: false,
      intervalId: null,
      showAll: true,
    };
  },
  mounted() {
    let lang = this.$route.query.lang;
    const langs = ['fi', 'sv', 'en'];
    let sessionLang = window.localStorage.getItem('locale');
    if (lang && langs.indexOf(lang) !== -1) {
      this.setLanguage(lang);
    } else if (sessionLang && langs.indexOf(sessionLang) !== -1) {
      this.setLanguage(sessionLang);
    } else {
      this.setLanguage('en');
    }
    if (this.$route.query.key) {
      this.$store.dispatch('user/setKey', this.$route.query.key);
      if (!this.user.authenticated) {
        this.$store.dispatch('user/authenticate', this.$route.query.key);
      }
    } else if (!this.user.authenticated) {
      this.showAll = false;
    }
  },
  methods: {
    ping() {
      if (!this.$store.getters['user/isAuthenticated']) {
        this.$store.dispatch('user/fetch').catch(() => {
          this.serverError = true;
        });
      }
    },
    setLanguage(lang) {
      this.$i18n.locale = lang;
      window.localStorage.setItem('locale', lang);
    },
  },
  computed: {
    ...mapGetters('user', ['user']),
  },
};
</script>

<style lang="scss">
@import '@/assets/base.scss';
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
